"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _ShareRound = _interopRequireDefault(require("@rsuite/icon-font/lib/action/ShareRound"));

// Generated by script, don't edit it please.
var ShareRound = (0, _createSvgIcon["default"])({
  as: _ShareRound["default"],
  ariaLabel: 'share round',
  category: 'action',
  displayName: 'ShareRound'
});
var _default = ShareRound;
exports["default"] = _default;
module.exports = exports.default;